import React, { useEffect, useState } from 'react';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
import { purchases } from '../data/content';
export function UrgencyBanner() {
  const [visible, setVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    const showPopup = () => {
      setCurrentPurchase(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      window.setTimeout(() => setVisible(false), 6500);
    };
    const initialTimer = window.setTimeout(showPopup, 3500);
    const interval = window.setInterval(showPopup, 18000);
    return () => {
      window.clearTimeout(initialTimer);
      window.clearInterval(interval);
    };
  }, []);
  if (!visible) return null;
  return <aside className="pointer-events-none fixed bottom-3 left-3 right-3 z-50 flex animate-slide-in justify-center sm:left-auto sm:right-4 sm:justify-end" aria-live="polite" data-id="element-168" data-mp="3b5wnwft3busr">
      <div className="pointer-events-auto relative w-full max-w-[300px] overflow-hidden rounded-lg border-2 border-brand-red bg-brand-black p-2.5 pr-8 text-white shadow-[0_8px_24px_rgba(17,17,17,0.45)]" data-id="element-169" data-mp="1gwcbar540j6j">
        <div className="absolute inset-x-0 top-0 h-1 bg-brand-gold" data-id="element-170" data-mp="22m6lmrihkdhf" />
        <button onClick={() => setVisible(false)} aria-label="Close purchase notification" className="absolute right-1.5 top-1.5 rounded p-0.5 text-white/60 hover:text-white focus:outline-none focus:ring-2 focus:ring-brand-red" data-id="element-171" data-mp="1xpg6c6ei9lx2">
          <XIcon className="h-4 w-4" data-id="element-172" data-mp="2le7veowsto5m" />
        </button>
        <div className="flex items-center gap-2.5" data-id="element-173" data-mp="2lcocsrno710o">
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-brand-red bg-brand-red/20" data-id="element-174" data-mp="2ged4ild0wykk">
            <ShoppingBagIcon className="h-4 w-4 text-brand-red" data-id="element-175" data-mp="2cdjcbfsjsxlv" />
          </div>
          <div className="leading-tight" data-id="element-176" data-mp="151srz93tvriv">
            <p className="text-xs font-bold" data-id="element-177" data-mp="10ynrtd7801xe">{currentPurchase.name}</p>
            <p className="text-[10px] font-medium text-white/70" data-id="element-178" data-mp="10xcnnc9v4s5r">from {currentPurchase.location}</p>
            <p className="mt-0.5 text-[11px] font-bold text-brand-gold" data-id="element-179" data-mp="12gkxrppmn800">
              just purchased BOXING COACH PRO™
            </p>
          </div>
        </div>
      </div>
    </aside>;
}